import React, { useState } from 'react';
import { PI_PUBLIC_PAGE_DATA } from '../../patient-invisalign-public/mockData';
import type { PatientInvisalignPublicPageProps } from '../../patient-invisalign-public/types';
import { PatientUrgencyDOBGate } from '../PatientUrgency/PatientUrgencyDOBGate';
import { PatientInvisalignPublicContent } from './PatientInvisalignPublicSections';

export function PatientInvisalignPublicPage({ data = PI_PUBLIC_PAGE_DATA }: PatientInvisalignPublicPageProps) {
  const [verified, setVerified] = useState(false);

  if (!verified) {
    return (
      <PatientUrgencyDOBGate
        practice={data.practice}
        patient={data.patient}
        onVerified={() => setVerified(true)}
        description="Please verify your date of birth to view your Invisalign profile."
        submitLabel="View my Invisalign profile"
      />
    );
  }

  return <PatientInvisalignPublicContent data={data} />;
}

export type { PatientInvisalignPublicPageProps };
